import { AnimType } from '@tencent/slide-sdk-model';

export const ANIM_CANVAS_PROPERTY = {
    X: 'x',
    Y: 'y',
    ANGLE: 'angle',
    ALPHA: 'alpha',
    SCALE_X: 'scaleX',
    SCALE_Y: 'scaleY',
};

export enum AnimCanvasProperty {
    X = 'x',
    Y = 'y',
    ANGLE = 'angle',
    ALPHA = 'alpha',
    SCALE_X = 'scaleX',
    SCALE_Y = 'scaleY',
    FILL_COLOR = 'fillColor',
    FONT_COLOR = 'fontColor',
    LINE_COLOR = 'lineColor',
    FONT_SIZE = 'fontSize',
}

export type ColorPropertyValues = AnimCanvasProperty.FILL_COLOR
    | AnimCanvasProperty.FONT_COLOR | AnimCanvasProperty.LINE_COLOR | AnimCanvasProperty.FONT_SIZE;

export const TIME_CONSTANTS = {
    OFFICE_MIN_TIME: 10,
    ONE_FRAME_MIN_TIME: 80,
};

export const DEFAULT_CANVAS_STYLE = {
    x: 0,
    y: 0,
    angle: 0,
    alpha: 1,
    scaleX: 1,
    scaleY: 1,
};

export const MAIN_TIMELINE_OPTIONS = {
    masterPaused: true,
    childPaused: false,
};

export const ACTIVITY = {
    name: 'activity',
    value: '1',
};

export const MEDIA = {
    VIDEO: 'video',
    AUDIO: 'audio',
};

export const POINTER = {
    NONE: 'none',
    AUTO: 'auto',
};

export const GROUP = 'Group';

// 采样间隔
export const SAMPLE_INTERVAL = {
    FREQUENT: 400, // 频繁，400ms
    MEDIUM: 950, // 中等，950ms
    COMMON: 1000, // 常用，1000ms
};

export enum AnimFilters {
    BLINDS = 'blinds',
    BOUNCE = 'bounce',
    CHECKERBOARD = 'checkerboard',
    DISSOLVE = 'dissolve',
    RANDOMBAR = 'random_bars',
    CIRCLE = 'circle',
    BARN = 'barn',
    STRIPS = 'strips',
    SPLIT = 'split',
    WEDGE = 'wedge',
    WHEEL = 'wheel',
    WIPE = 'wipe',
    CUT = 'cut', // cut_in and cut_out
    SHAPE_CIRCLE = 'shape_circle',
    SHAPE_BOX = 'shape_box',
    SHAPE_DIAMOND = 'shape_diamond',
    SHAPE_PLUS = 'shape_plus'
}

export enum Action {
    ENTR = 'entr',
    EXIT = 'exit'
}

export enum LayerType {
    BASE = 'base',
    OPERATION = 'operation',
    OVERLAY = 'overlay',
}

export const AllowLayer = true;

export const ALL_COLOR_LIST = [
    AnimCanvasProperty.FILL_COLOR,
    AnimCanvasProperty.FONT_COLOR,
    AnimCanvasProperty.LINE_COLOR,
];
const FILL_FONT_LIST = [AnimCanvasProperty.FILL_COLOR, AnimCanvasProperty.FONT_COLOR];

export const COLOR_ANIM_TYPE_MAP = {
    [AnimType.FillColor]: [AnimCanvasProperty.FILL_COLOR],
    [AnimType.FontColor]: [AnimCanvasProperty.FONT_COLOR],
    [AnimType.BrushColor]: FILL_FONT_LIST,
    [AnimType.ComplementaryColor]: ALL_COLOR_LIST,
    [AnimType.ComplementaryColor2]: ALL_COLOR_LIST,
    [AnimType.ContrastingColor]: ALL_COLOR_LIST,
    [AnimType.Darken]: ALL_COLOR_LIST,
    [AnimType.Desaturate]: ALL_COLOR_LIST,
    [AnimType.Lighten]: ALL_COLOR_LIST,
    [AnimType.ObjectColor]: FILL_FONT_LIST,
    [AnimType.ColorPulse]: FILL_FONT_LIST,
    [AnimType.GrowWithColor]: FILL_FONT_LIST,
};

export const ATTR_LIST = [
    ...ALL_COLOR_LIST,
    AnimCanvasProperty.FONT_SIZE,
];

export const COLOR = {
    black: 'rgba(0,0,0,1)',
    white: 'rgba(255,255,255,1)',
};
